<div style="position: relative">

  <monitoring-header componentName="{{ serviceName }}"></monitoring-header>

  <div style="margin-top: 25px">
    <div class="pagenation" style="display: flex; justify-content: center">
      <mat-form-field appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input
          matInput
          #ref
          [matDatepicker]="picker"
          [formControl]="selectedDate"
          (dateChange)="onDateChange(ref.value)"
          [disabled]="key === 'usersLoggedInToday'"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div id="block_container">
      <div id="bloc1">
        <app-user-list-bar-chart
          [labels]="top10UserIds"
          [data]="top10NoOfRequests"
          (selectedUser)="onUserChartSelected($event)"
        ></app-user-list-bar-chart>
      </div>
      <div id="bloc2">
        <line-chart
          [labels]="top10ApiList"
          [data]="top10ResponseTimes"
          (selectedUser)="onApiChartSelected($event)"
        ></line-chart>
      </div>
    </div>

    <div id="block_container">
      <div id="bloc1">
        <div class="table-wrapper">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="userID">
            <th mat-header-cell *matHeaderCellDef>User Id</th>
            <td mat-cell *matCellDef="let element">{{ element.userID }}</td>
          </ng-container>

          <ng-container matColumnDef="noOfRequest">
            <th mat-header-cell *matHeaderCellDef>No. Of Request</th>
            <td mat-cell *matCellDef="let element">{{ element.noOfRequest }}</td>
          </ng-container>

          <ng-container matColumnDef="minResponseTime">
            <th mat-header-cell *matHeaderCellDef>Min Response Time</th>
            <td mat-cell *matCellDef="let element">
              {{ element.minResponseTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="minResponseService">
            <th mat-header-cell *matHeaderCellDef>Min Response Service</th>
            <td mat-cell *matCellDef="let element">
              {{ element.minResponseService }}
            </td>
          </ng-container>

          <ng-container matColumnDef="maxResponseTime">
            <th mat-header-cell *matHeaderCellDef>Max Response Time</th>
            <td mat-cell *matCellDef="let element">
              {{ element.maxResponseTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="maxResponseService">
            <th mat-header-cell *matHeaderCellDef>Max Response Service</th>
            <td mat-cell *matCellDef="let element">
              {{ element.maxResponseService }}
            </td>
          </ng-container>

          <ng-container matColumnDef="loggedInTime">
            <th mat-header-cell *matHeaderCellDef>Loggedin Time</th>
            <td mat-cell *matCellDef="let element">
              {{ element.loggedInTime | date: "MM/dd/yyyy HH:mm:ss" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="averageResponseTime">
            <th mat-header-cell *matHeaderCellDef>Avg Response Time</th>
            <td mat-cell *matCellDef="let element">
              {{ element.averageResponseTime }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onUserRowclick(row)"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              No Records.
            </td>
          </tr>
        </table>
        </div>
        <mat-paginator
          class="pagenation mat-elevation-z8"
          #paginator
          [pageSizeOptions]="[10, 15, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
      <div id="bloc2">
        <div class="table-wrapper">
          <table
            mat-table
            [dataSource]="apiActivityListdataSource"
            matSort
          >
            <ng-container matColumnDef="api">
              <th mat-header-cell *matHeaderCellDef>Api</th>
              <td mat-cell *matCellDef="let element">{{ element.api }}</td>
            </ng-container>

            <ng-container matColumnDef="averageResponseTime">
              <th mat-header-cell *matHeaderCellDef>Avg Response Time</th>
              <td mat-cell *matCellDef="let element">
                {{ element.averageResponseTime }}
              </td>
            </ng-container>

            <ng-container matColumnDef="firstRequestTime">
              <th mat-header-cell *matHeaderCellDef>First Request Time</th>
              <td mat-cell *matCellDef="let element">
                {{ element.firstRequestTime | date: "MM/dd/yyyy HH:mm:ss" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maxResponseTime">
              <th mat-header-cell *matHeaderCellDef>Max Response Time</th>
              <td mat-cell *matCellDef="let element">
                {{ element.maxResponseTime }}
              </td>
            </ng-container>

            <ng-container matColumnDef="minResponseTime">
              <th mat-header-cell *matHeaderCellDef>Min Response Time</th>
              <td mat-cell *matCellDef="let element">
                {{ element.minResponseTime }}
              </td>
            </ng-container>

            <ng-container matColumnDef="noOfUserAccessed">
              <th mat-header-cell *matHeaderCellDef>No of User Accessed</th>
              <td mat-cell *matCellDef="let element">
                {{ element.noOfUserAccessed }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="apiActivitydisplayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: apiActivitydisplayedColumns"
              (click)="onApiListRowclick(row)"
            ></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                No Records.
              </td>
            </tr>
          </table>
        </div>
        <mat-paginator
          class="pagenation mat-elevation-z8"
          #apiActivityPaginator
          [pageSizeOptions]="[10, 15, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>

  <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
  </div>
</div>